import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';
import RangoLogo from '../../assets/img/site/logoRangoComercialBlanco.svg';
//import FacebookIcon from '../../assets/img/site/iconFacebookFooter.gif';
import FacebookIcon from '../../assets/img/site/f_logo.png';
import InstagramIcon from '../../assets/img/site/Instagram.png';

const Footer = () => {
	return (
		<>
			<div className="footerImg"> </div>
			<footer>
				<div className="container">
					<div className="row">
						<div className="col-12 logoEmpresa text-center mb-3 mb-sm-0">
							<img src={RangoLogo} alt="Logo Rango Comercial" />
						</div>

						<div className="col-12 text-center my-3 mb-sm-0 d-flex flex-row justify-content-center align-items-center">
							<p className="font-weight-bold text-xs-center">
								<strong>¡Seguinos&nbsp;</strong>{" en las Redes!"}
								<a className="topHeader__icon" target="_blank" href="https://www.facebook.com/rangocomercial">
									<img src={FacebookIcon} alt="logo facebook" title="Ir a nuestro Facebook" />
									{/* <i className="fa fa-facebook-square fa-2x" aria-hidden="true"></i> */}
								</a>
								<a className="topHeader__icon" target="_blank" href="https://www.instagram.com/rangocomercial/">
									<img src={InstagramIcon} alt="logo Instagram" title="Ir a nuestro Instagram" />
									{/* <i className="fa fa-instagram fa-2x" aria-hidden="true"></i> */}
								</a>
								<Link className="topHeader__icon" to="/contacto">
									<i className="fa fa-envelope fa-2x" aria-hidden="true" title="Enviar un Mail"></i>
								</Link>
							</p>
						</div>

						<div className="col-12 mt-5">
							<div className="sucursales">
								<address className="sucursal">
									<strong>MÉDANOS</strong>
									<i className="fa fa-map-marker" aria-hidden="true"></i> Anchorena 123
									<a href="tel:2927432089"><i className="fa fa-phone-square" aria-hidden="true"></i> 2927 432089</a>
									<a target="_blank" href="https://api.whatsapp.com/send?phone=5492914045440&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20producto"><i className="fa fa-whatsapp" aria-hidden="true"></i> 291 15 4045440</a>
									{/* <a href="mailto:medanos@rangocomercial.com.ar"><i className="fa fa-envelope" aria-hidden="true"></i> Contactar</a> */}
									<Link to="/contacto"><i className="fa fa-envelope" aria-hidden="true"></i> Contactar</Link>
								</address>
								<address className="sucursal">
									<strong>RÍO COLORADO</strong>
									<i className="fa fa-map-marker" aria-hidden="true"></i> Urquiza 571
									<a href="tel:2931432822"><i className="fa fa-phone-square" aria-hidden="true"></i> 2931 432822</a>
									<a target="_blank" href="https://api.whatsapp.com/send?phone=5492916415010&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20producto"><i className="fa fa-whatsapp" aria-hidden="true"></i> 291 15 6415010</a>
									{/* <a href="mailto:riocolorado@rangocomercial.com.ar"><i className="fa fa-envelope" aria-hidden="true"></i> Contactar</a> */}
									<Link to="/contacto/riocolorado"><i className="fa fa-envelope" aria-hidden="true"></i> Contactar</Link>
								</address>
								<address className="sucursal">
									<strong>ALGARROBO</strong>
									<i className="fa fa-map-marker" aria-hidden="true"></i> Av. 25 de Mayo 214
									<a href="tel:2927491289"><i className="fa fa-phone-square" aria-hidden="true"></i> 2927 491289</a>
									<a target="_blank" href="https://api.whatsapp.com/send?phone=5492916429255&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20producto"><i className="fa fa-whatsapp" aria-hidden="true"></i> 291 15 6429255</a>
									{/* <a href="mailto:algarrobo@rangocomercial.com.ar"><i className="fa fa-envelope" aria-hidden="true"></i> Contactar</a> */}
									<Link to="/contacto/algarrobo"><i className="fa fa-envelope" aria-hidden="true"></i> Contactar</Link>
								</address>
								<address className="sucursal">
									<strong>VILLALONGA</strong>
									<i className="fa fa-map-marker" aria-hidden="true"></i> N. Sra. d/Carmen 218
									<a href="tel:2928492425"><i className="fa fa-phone-square" aria-hidden="true"></i> 2928 492425</a>
									<a target="_blank" href="https://api.whatsapp.com/send?phone=5492916429466&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20producto"><i className="fa fa-whatsapp" aria-hidden="true"></i> 291 15 6429466</a>
									{/* <a href="mailto:villalonga@rangocomercial.com.ar"><i className="fa fa-envelope" aria-hidden="true"></i> Contactar</a> */}
									<Link to="/contacto/villalonga"><i className="fa fa-envelope" aria-hidden="true"></i> Contactar</Link>
								</address>
								<address className="sucursal">
									<strong>HILARIO ASCASUBI</strong>
									<i className="fa fa-map-marker" aria-hidden="true"></i> Ing. Urgoiti 475
									<a href="tel:2928491133"><i className="fa fa-phone-square" aria-hidden="true"></i> 2928 491133</a>
									<a target="_blank" href="https://api.whatsapp.com/send?phone=5492916422233&text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20producto"><i className="fa fa-whatsapp" aria-hidden="true"></i> 291 15 6422233</a>
									{/* <a href="mailto:ascasubi@rangocomercial.com.ar"><i className="fa fa-envelope" aria-hidden="true"></i> Contactar</a> */}
									<Link to="/contacto/ascasubi"><i className="fa fa-envelope" aria-hidden="true"></i> Contactar</Link>
								</address>
							</div>
						</div>
					</div>

					<div className="row copy">
						<div className="col-sm-9">
							<p>
								<span className="text-nowrap">© {(new Date()).getFullYear()} <Link to="/"> RANGO COMERCIAL S.A. </Link></span>{" | "}
								<span className="text-nowrap">Todos los derechos reservados.</span>{" | "}
								<span className="text-nowrap">Desarrollado por <a target="_blank" href="https://www.paradigma.com.ar/" className="font-weight-bold text-white">Paradigma del Sur S.A.</a></span>
							</p>
						</div>
						<div className="col-sm-3 text-md-right">
							{/* <p className="d-flex">
								<strong>Seguinos&nbsp;</strong>{" en las Redes!"}
								<a className="topHeader__icon" target='_blank' href="https://www.facebook.com/rangocomercial">
									<i className="fa fa-facebook-square fa-2x" aria-hidden="true"></i>
								</a>
								<a className="topHeader__icon" target='_blank' href="https://www.instagram.com/rangocomercial/">
									<i className="fa fa-instagram fa-2x" aria-hidden="true"></i>
								</a>
							</p> */}
						</div>
					</div>
				</div>
			</footer>
		</>
	);
}

export default Footer;
